'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTime = function TiTime(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 21.7c0-0.9-0.8-1.7-1.7-1.7h-5c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.6 1.7 1.6h5c0.9 0 1.7-0.7 1.7-1.6z m-6.7-11.7c6.4 0 11.7 5.2 11.7 11.7s-5.3 11.6-11.7 11.6-11.7-5.2-11.7-11.6 5.3-11.7 11.7-11.7z m0-3.3c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z m1.7 10c0-0.9-0.8-1.7-1.7-1.7s-1.7 0.8-1.7 1.7v5c0 0.9 0.8 1.6 1.7 1.6s1.7-0.7 1.7-1.6v-5z m-1.7-3.4c4.6 0 8.3 3.8 8.3 8.4s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3 3.7-8.4 8.3-8.4z m0-1.6c-5.5 0-10 4.4-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10c0-5.6-4.5-10-10-10z' })
        )
    );
};

exports.default = TiTime;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/time.js
// module id = 3801
// module chunks = 0